import React from "react";
import { useLocation, Outlet } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import Navbar from "./Navbar";
import Footer from "./Footer";

// Layout component props
interface LayoutProps {
  children?: React.ReactNode;
  loadFooter?: boolean;
  navbarType?: string;
  hideNavForAuth?: boolean;
  footerBelowFold?: boolean; // if true, require scroll to reach footer
}

const Layout: React.FC<LayoutProps> = ({
  children,
  loadFooter = true,
  navbarType = 'default',
  hideNavForAuth = false,
  footerBelowFold = false,
}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  // Identify homepage to apply gradient background and transparent navbar
  const isHomePage = currentPath === "/";
  // Pages that should use the darker chat-like background
  const darkBgRoutes = new Set([
    "/chat",
    "/dashboard",
    "/courses",
    "/profile",
    "/documents",
    "/404"
  ]);
  const shouldUseDarkBg = true; // enforce dark background across app pages
  const isPricingPage = currentPath.startsWith('/pricing');
  // Use theme-aware background from CSS variables
  const pageBg = "var(--color-bg)";
  const content = children ?? <Outlet />;

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
      bg={pageBg}
    >
      {/* Conditionally hide nav for auth pages */}
      {!hideNavForAuth && <Navbar currentPath={currentPath} />}
      <Box as="main" flex="1" width="100%" minHeight={footerBelowFold ? "calc(100vh + 200px)" : undefined}>
        {content}
      </Box>
      {loadFooter && <Footer />}
    </Box>
  );
};

export default Layout;
